import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { getPublicDoc } from '../../../crud/docs.crud';
import { setLayoutFooter, setLayoutSubheader } from '../../../utils/layout';
import { getDocFromPathname } from './utils';

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
    backgroundColor: '#fff',
    padding: 30,
  },
  content: {
    minHeight: 400,
    width: '95%',
  },
}));

interface IDocument {
  code: string;
  name: string;
  text: string;
  public: boolean;
  id?: number;
}

function ReadDocPage() {
  const classes = useStyles();
  const intl = useIntl();
  const [userDocument, setDocument] = useState<IDocument | null>(null);

  const { type } = useParams();

  const document = getDocFromPathname(type || '', intl);

  setLayoutSubheader({
    title: document.name,
    breadcrumb: [],
  });
  setLayoutFooter({ show: true });

  useEffect(() => {
    getPublicDoc(document.code)
      .then(({ data: requestData }) => {
        setDocument(requestData.data);
      })
      .catch(() => {
        setDocument(null);
      });
  }, [type, document.code]);

  return (
    <div className={classes.container}>
      <div
        className={classes.content}
        dangerouslySetInnerHTML={{ __html: userDocument?.text || '' }}
      />
    </div>
  );
}
export default ReadDocPage;
